import './Matches.scss';

import { useMemo } from 'react';

const MATCHES = [
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'ESPN 2',
        home: 'Almere City FC',
        away: 'sc Heerenveen',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'ESPN 3',
        home: 'Fortuna Sittard',
        away: 'Go Ahead Eagles',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'FC Dordrecht',
        away: 'Willem II',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'ESPN 4',
        home: 'Roda JC',
        away: 'SC Cambuur',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'Telstar',
        away: 'FC Groningen',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'NAC Breda',
        away: 'ADO Den Haag',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'FC Den Bosch',
        away: 'FC Emmen',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'Jong AZ',
        away: 'MVV Maastricht',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'De Graafschap',
        away: 'Jong FC Utrecht',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'Helmond Sport',
        away: 'FC Eindhoven',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'Jong PSV',
        away: 'TOP Oss',
    },
    {
        date: '5/3/24',
        time: '20:00:00',
        channel: 'Extra',
        home: 'VVV-Venlo',
        away: 'Jong Ajax',
    },
    {
        date: '5/5/24',
        time: '12:15:00',
        channel: 'ESPN 1',
        home: 'PSV',
        away: 'Sparta Rotterdam',
    },
    {
        date: '5/5/24',
        time: '12:15:00',
        channel: 'ESPN 2',
        home: 'Heracles Almelo',
        away: 'RKC Waalwijk',
    },
    {
        date: '5/5/24',
        time: '14:30:00',
        channel: 'ESPN 4 + ESPN 1',
        home: 'FC Utrecht',
        away: 'Vitesse',
    },
    {
        date: '5/5/24',
        time: '14:30:00',
        channel: 'ESPN 3',
        home: 'FC Volendam',
        away: 'Ajax',
    },
    {
        date: '5/5/24',
        time: '16:45:00',
        channel: 'ESPN 1',
        home: 'AZ',
        away: 'FC Twente',
    },
    {
        date: '5/5/24',
        time: '20:00:00',
        channel: 'ESPN 1',
        home: 'Feyenoord',
        away: 'PEC Zwolle',
    },
    {
        date: '5/6/24',
        time: '20:00:00',
        channel: 'ESPN 1 (+ evt ESPN 2)',
        home: 'Excelsior',
        away: 'N.E.C.',
    },
    {
        date: '5/10/24',
        time: '20:00:00',
        channel: 'Extra',
        note: '6 wedstrijden op Extra',
    },
    { date: '5/10/24', time: '20:00:00', channel: 'ESPN 2' },
    {
        date: '5/10/24',
        time: '20:00:00',
        channel: 'ESPN 3',
    },
    {
        date: '5/10/24',
        time: '20:00:00',
        channel: 'ESPN 4',
    },
    {
        date: '5/10/24',
        time: '20:00:00',
        channel: 'Extra',

        away: '6 wedstrijden op Extra',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'ESPN 1',
        home: 'FC Twente',
        away: 'Telstar',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'ESPN 2',
        home: 'ADO Den Haag',
        away: 'Ajax',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'ESPN 3',
        home: 'PSV',
        away: 'Excelsior',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'ESPN 4',
        home: 'Feyenoord',
        away: 'FC Utrecht',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'Extra',
        home: 'AZ',
        away: 'sc Heerenveen',
    },
    {
        date: '5/11/24',
        time: '16:30:00',
        channel: 'Extra',
        home: 'PEC Zwolle',
        away: 'Fortuna Sittard',
    },
    {
        date: '5/12/24',
        time: '14:20:00',
        channel: 'ESPN 1',
        home: 'Schakelprogramma',
    },
    // { date: '5/12/24', time: '14:30:00', channel: 'ESPN 2' },
    // { date: '5/12/24', time: '14:30:00', channel: 'ESPN 3' },
    // { date: '5/12/24', time: '14:30:00', channel: 'ESPN 4' },
    // {
    //     date: '5/12/24',
    //     time: '14:30:00',
    //     channel: 'Extra',

    //     note: '6 wedstrijden op Extra',
    // },
    // {
    //     date: '5/13/24',
    //     time: '20:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/14/24',
    //     time: '18:45:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/14/24',
    //     time: '21:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/17/24',
    //     time: '20:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/18/24',
    //     time: '16:30:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/18/24',
    //     time: '20:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Eerste ronde',
    // },
    // {
    //     date: '5/19/24',
    //     time: '14:20:00',
    //     channel: 'ESPN 1',
    //     home: 'Schakelprogramma',
    // },
    // { date: '5/19/24', time: '14:30:00', channel: 'ESPN 2' },
    // { date: '5/19/24', time: '14:30:00', channel: 'ESPN 3' },
    // { date: '5/19/24', time: '14:30:00', channel: 'ESPN 4' },
    // {
    //     date: '5/19/24',
    //     time: '14:30:00',
    //     channel: 'Extra',
    //     note: '6 wedstrijden op Extra',
    // },
    // { date: '5/20/24', time: '14:30:00', channel: 'ESPN 1', home: 'Finale' },
    // {
    //     date: '5/21/24',
    //     time: '20:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // {
    //     date: '5/22/24',
    //     time: '18:45:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // {
    //     date: '5/23/24',
    //     time: '18:45:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // {
    //     date: '5/23/24',
    //     time: '21:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // {
    //     date: '5/25/24',
    //     time: '16:30:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // {
    //     date: '5/25/24',
    //     time: '20:00:00',
    //     channel: 'ESPN 1',
    //     home: 'Halve finale',
    // },
    // { date: '5/26/24', time: '14:00:00', channel: 'ESPN 1', home: 'Finale' },
    // { date: '5/26/24', time: '18:00:00', channel: 'ESPN 1', home: 'Finale' },
    // { date: '5/28/24', time: '20:00:00', channel: 'ESPN 1', home: 'Finale' },
    // { date: '6/2/24', time: '18:00:00', channel: 'ESPN 1', home: 'Finale' },
];

const Matches = ({ image }) => {
    const matchesStyle = {
        backgroundImage: `url(${image})`,
    };

    const normalizedMatches = useMemo(() => {
        return MATCHES.map(match => {
            let columnText;

            if (match.home) {
                columnText =
                    `${match.home}` + (match.away ? ` - ${match.away}` : '');
            } else if (match.note) {
                columnText = match.note;
            } else {
                columnText = 'n.t.b.';
            }

            return {
                date: new Date(match.date).toLocaleDateString('nl-NL', {
                    day: 'numeric',
                    month: 'long',
                }),
                column: columnText,
                channel: match.channel,
            };
        });
    });

    return (
        <section
            id="matches"
            className="Matches__showdown"
            style={matchesStyle}
        >
            <div className="container">
                <h2 className="heading heading--medium heading--white text--center">
                    Bekijk wedstrijdoverzicht
                </h2>
                <p className="text text--white text--center">
                    Bekijk hieronder de belangrijke wedstrijden van de
                    Ontknoping.
                </p>
                <div className="matches">
                    {normalizedMatches.map((match, index) => (
                        <div key={index} className="match">
                            <div className="date text text--white">
                                {match.date}
                            </div>
                            <div className="column text text--white">
                                {match.column}
                            </div>
                            <div className="channel text text--white">
                                {match.channel}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="disclaimer text text--white text--center">
                    <p>
                        Heb je een ESPN Compleet abonnement bij een
                        tv-aanbieder? Bekijk via de viedo hieronder hoe je
                        gratis toegang hebt tot de ESPN EXTRA-kanalen.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Matches;
